import envBeam from '@beam-australia/react-env';
export default function env(key: string): string {
  if (!global.jest) {
    return envBeam(key);
  }
  return process.env[key];
}
